import { useNavigate } from 'react-router-dom';
import OnboardingTour, { type TourStep } from '../components/onboarding/OnboardingTour';

// Sprint ACAD ACT.A8 (#1709) — student first-login tour (5 steps, per the
// AC): Welcome → Find your workspace → Read your BRD → Meet your first
// agent → Done/badge. Q5 adjudication: "Meet your first agent" is a static
// informational screen for v1, not a live guided session.

const STEPS: TourStep[] = [
  {
    title: 'Welcome to BluePrint',
    body: "You've been added to your academic team's workspace. This short tour gets you oriented before your orientation workshop.",
  },
  {
    title: 'Find your workspace',
    body: 'Your team project lives under Projects — that\'s where your BRD, agent sessions, and deliverables all live.',
  },
  {
    title: 'Read your BRD',
    body: 'Every project starts from a Business Requirements Document (BRD). Your faculty supervisor or team lead can share it with you from the project dashboard.',
  },
  {
    title: 'Meet your first agent',
    body: "BluePrint's AI agents guide each phase of your project — from requirements to deployment. You'll work with them directly inside a project's Chat tab.",
  },
  {
    title: "You're all set",
    body: 'You now know your way around. See you at the orientation workshop!',
    cta: 'Done',
  },
];

export default function StudentOnboardingPage() {
  const navigate = useNavigate();
  return (
    <OnboardingTour
      flowType="STUDENT"
      steps={STEPS}
      onDone={() => navigate('/projects', { replace: true })}
    />
  );
}
